import { create } from 'zustand';

export interface HeaderStoreType {
  isSideMenuOpen: boolean;
  isBackButtonVisible: boolean;
  backButtonDestination: '/thank-you' | '/report';
  isLogoVisible: boolean;
  isHeaderVisible: boolean;
  isReportButtonVisible: boolean;
  isInfoMenuButtonCompact: boolean;
  headerOffset: number;
  setHeaderSettings: (settings: Partial<HeaderStoreType>) => void;
  toggleSideMenu: () => void; // Added toggle function
}

export const useHeaderStore = create<HeaderStoreType>(set => ({
  isSideMenuOpen: false,
  isBackButtonVisible: false,
  backButtonDestination: '/thank-you',
  isLogoVisible: true,
  isHeaderVisible: true,
  isReportButtonVisible: false,
  isInfoMenuButtonCompact: false,
  headerOffset: 0,
  setHeaderSettings: settings => set(state => ({ ...state, ...settings })),
  toggleSideMenu: () =>
    set(state => ({ isSideMenuOpen: !state.isSideMenuOpen })),
}));
